export default __webpack_public_path__ + "static/media/mac-app-logo-128.5dc3360f.png";